import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-02-26 16:06:10
 * @LastEditTime: 2022-03-21 15:05:52
 * @LastEditors: wangshengqiang
 * @Description: 渲染方法
 */
import React, { Suspense, useContext } from 'react';
import { FormContext } from '@/store/context'; // eslint-disable-next-line import/no-cycle
// import BizComponents from './index';
// import BaseModule from './BaseModule';

import Gs from '../Gs'; // console.log('Gs: ', Gs);

export default function Render(props) {
  const BizComponents = Gs.componentMap;
  const {
    BaseModule
  } = Gs.componentMap;
  const {
    components
  } = props;
  const form = useContext(FormContext);
  if (!components || !components.length) return null;
  return components.map(item => {
    if (!item || item.isDefault !== undefined && !item.isDefault) return null; // 支持原生html标签下嵌套字符串

    if (typeof item === 'string') {
      return item;
    }

    const componentName = item.component;
    const {
      formKey
    } = item;
    let Component = null; // if(item.path) {
    //   Component = React.lazy(() => import(`${item.path}`) )
    // } else {
    //   Component = BizComponents[componentName] || BizComponents.noModule;
    // }

    Component = BizComponents[componentName] || BaseModule;

    if (!BizComponents[componentName]) {
      console.warn(`${componentName}组件不存在，请检查。`, item);
      if (!BaseModule) return null;
    }

    const _key = item.id ? `componentName_${item.id}` : `componentName_${formKey}`;

    const _key2 = item.id ? `component_${item.id}` : `componentName_${formKey}`;

    return /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", null, "Loading...")
    }, /*#__PURE__*/React.createElement(Component, _extends({
      name: componentName,
      form: form
    }, item, {
      Render: Render
    })));
  });
}